// extracted by mini-css-extract-plugin
export default {"iconCityDistance":"CityCenterDistanceFeature-module__iconCityDistance__drkyC"};